import { createStore, combineReducers, applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';

import auth from './Models/Auth/reducer';
import admin from './Models/Admin/reducer';
import application from './Models/Application/reducer';

const rootReducers = combineReducers({
    application,
    admin,
    auth
});

// Simplified store setup without devtools
const store = createStore(
    rootReducers,
    applyMiddleware(thunk)
);

export default store;
